import createToolbarWithPlugin from '../../features/TextEditor/createToolbarWithPlugin'

describe('createToolbarWithPlugin', () => {
  it('should return ToolbarComponent and toolbarplugin true', () => {
    const { ToolbarComponent, toolbarPlugin } = createToolbarWithPlugin()
    expect(ToolbarComponent).toBeTruthy()
    expect(toolbarPlugin.Toolbar).not.toBeNull()
    expect(toolbarPlugin.initialize).not.toBeNull()
    expect(toolbarPlugin.onChange).not.toBeNull()
  })
})
